module.exports = __webpack_public_path__ + "img/BlinkArt_Sword11_Dark.0f1a961e.png";